import isArray from 'lodash/isArray';
import find from 'lodash/find';
import type {
  SettingsDTO,
  FilterableSettingDTO,
  FilterableOptionDTO,
} from '@/dtos';
import {
  notEmptyString,
} from './misc';

export type SimpleOption = { label: string; value: string };

function findSetting(
  settings?: SettingsDTO | null,
  predicate?: (s: FilterableSettingDTO) => boolean,
): FilterableSettingDTO | undefined {
  const list = (settings?.filterableSettings ?? []) as FilterableSettingDTO[] | null | undefined;
  if (!isArray(list)) return undefined;
  return find(list, predicate);
}

export function getProviderOptionsFromSettings(settings?: SettingsDTO | null): SimpleOption[] {
  const match = findSetting(settings, (setting) => {
    const displayName = (setting?.displayName ?? '').toLowerCase();
    return displayName.includes('provider') || displayName.includes('doctor');
  });
  const options = (match?.optionList ?? []) as FilterableOptionDTO[] | null;
  return !isArray(options) ? [] :(options ?? [])
    .map((opt) => ({ label: opt?.displayName ?? '', value: opt?.value?.toString() ?? '' }))
    .filter((o) => notEmptyString(o.label) && notEmptyString(o.value));
}

export function getStatusOptionsFromSettings(settings?: SettingsDTO | null): SimpleOption[] {
  const match = findSetting(settings, (setting) => {
    const displayName = (setting?.displayName ?? '').toLowerCase();
    const isStatus = displayName.includes('status');
    const related = displayName.includes('checklist');
    return isStatus && related;
  });

  const options = (match?.optionList ?? []) as FilterableOptionDTO[] | null;
  return !isArray(options) ? [] : (options ?? [])
    .map((opt) => ({ label: opt?.displayName ?? '', value: opt?.value?.toString() ?? '' }))
    .filter((o) => notEmptyString(o.label) && notEmptyString(o.value));
}
